
export const flags = {
    EXCLUSIVE_WEBINAR_ACCESS: 'LXP.EXCLUSIVE.WEBINAR.ACCESS',
    DEFAULT_HOME_FILTER: 'LXP.DEFAULT.HOME.FILTER',
    GAMIFICATION_PROGRESS: 'LXP.GAMIFICATION.ACCESS',
    TERMS_AND_CONDITIONS: 'LXP.TERMS.ENABLED',
    NOTIFICATIONS: 'LXP.NOTIFICATIONS.ENABLED',
};

export const defaultValues = {
    [ flags.EXCLUSIVE_WEBINAR_ACCESS ]: false,
    [ flags.DEFAULT_HOME_FILTER ]: undefined,
    [ flags.GAMIFICATION_PROGRESS ]: false,
    [ flags.TERMS_AND_CONDITIONS ]: false,
    [ flags.NOTIFICATIONS ]: true,
};